import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { executivesData } from "@/data/executives";
import { homeUrl } from "@/lib/assets";

export const Leadership: React.FC = () => {
  return <section id="leadership-section" className="acad-about-leadership bg-background py-16 md:py-24 overflow-hidden w-full">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div className="flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center justify-center rounded-full bg-destructive px-3.5 py-1 text-xs font-bold uppercase tracking-wider text-destructive-foreground">
              LIDERAZGO
            </span>
            <h2 className="text-2xl font-black uppercase tracking-tight text-foreground sm:text-3xl md:text-4xl">
              EJECUTIVO NACIONAL
            </h2>
          </div>
          <p className="acad-executive-count">8 líderes al servicio de la iglesia</p>
        </div>

        <div className="acad-executive-grid">
          {executivesData.map((exec) => <article key={exec.id} className="acad-executive-card">
              <div className="acad-executive-media">
                <img src={exec.image} alt={exec.name} loading="lazy" />
                <span className="acad-executive-number">{exec.number}</span>
              </div>
              <div className="acad-executive-panel">
                <span className="acad-executive-role">{exec.role}</span>
                <h3>{exec.name}</h3>
                <p>{exec.bio}</p>
                <Link className="acad-executive-profile-button" to={homeUrl(`${exec.slug}/`)}>
                  Ver perfil <ArrowUpRight aria-hidden="true" />
                </Link>
              </div>
            </article>)}
                </div>
      </div>
    </section>;
};
export default Leadership;
